import React, { useContext, useEffect, useState } from 'react';
import PodriaInteresarte from '../home/PodriaInteresarte';
import AgregadoItem from '../home/AgregadoItem';
import axios from "@fetch/axios";
import { TokenContext } from '@context/TokenContext';
import { useNavigate } from 'react-router-dom';
import { LanguageCurrencyContext } from '@context/LanguageCurrencyContext';
import { useTranslation } from '@hooks/useTranslation';
import GiftProduct from "@components/GiftProduct";
import PedidosLoading from "@components/PedidosLoading";

const Component = () => {

	const [openPanelIndex, setOpenPanelIndex] = useState(null); // Estado para el panel abierto
	const { getToken } = useContext(TokenContext);
  	const navigate = useNavigate();
  	const { lang, currency } = useContext(LanguageCurrencyContext);
	const  {translate}    = useTranslation();
	// Función para alternar el panel
	const togglePanel = (index) => {
		setOpenPanelIndex(openPanelIndex === index ? null : index);
	};

	const [pedidos, setPedidos] = useState([])
	const [loadingp, setLoadingp] = useState(false)

	useEffect(() => {

		const fetchPedidos = async () => {

			try {
				setLoadingp(false)
				const res = await axios.get('/cart/orders'+ `?lang=` + lang + `&currency=` + currency,
					{
						headers: { 'Authorization': 'Bearer ' + getToken() }
					}
				);
				setLoadingp(true)
				if (res.data) {
					setPedidos(res.data);
				}


			} catch (error) {
				setLoadingp(false)
			}
		};

		fetchPedidos()

	}, [lang,currency])


	return (
		<>
			<div className={`CategoryTitle PerfilSection pt-tophead`}>
				<ul className="Breadcrumb">
					<li onClick={() => { navigate('/home') }} style={{ cursor: "pointer" }}>Home</li>
					<li onClick={() => { navigate('/mi-perfil') }} style={{ cursor: "pointer" }}>{translate('view.myprofile.my_profile')}</li>
					<li>{translate('view.orders.title')}</li>
				</ul>
			</div>

			<section className="MisPedidos">
				{loadingp ? 
				(pedidos.length > 0 && pedidos.map((pedido, index) => (
					<div className="itemPedido" key={pedido.id}>
						<div className="tab">
							<div>
								{pedido.detail.guest==1 ? (<div>
									<div className="order-identifier">
										<div className="icon-UserStar"></div>
										<span className="identifier-text">{translate('checkout.guest_title')}</span>
									</div>
								</div>) : ''}
								<div>
									<div className="title">{translate('orders.id')}:</div>
									<span className="id-pedido"><strong>{pedido.id}</strong></span>
								</div>
								<div>
									<div className="title"><strong>{translate('orders.realized')}:</strong></div>
									<span>{pedido.date}</span>
								</div>
							</div>
							<div>
								<div>
									<div className="title">Total:</div>
									<span className="total"><strong>{pedido.total}</strong></span>
								</div>
								<div>
									<button
										className="btn"
										onClick={() => togglePanel(index)}
									>
										{openPanelIndex === index ? translate('orders.hide') : translate('orders.show')}
									</button>
								</div>
							</div>
						</div>
						{/* Mostrar u ocultar el panel según el estado */}
						{openPanelIndex === index && (
							<div className="panel">
								<div className="detail">
									<div>
										<div className="title">{translate('orders.address')}:</div>
										<span>{pedido.detail.shipment_address}</span>
									</div>
									<div>
										<div className="title">{translate('orders.status')}:</div>
										<div className="box-status">
											{pedido.detail.status} <a href={pedido.detail.waybill}>{translate('orders.track')}</a>
										</div>
										<br />
										<div className="box-status">
											<a onClick={()=>{navigate('/cambios-y-devoluciones')}}>{translate('orders.policies')}</a>
										</div>
									</div>
									<div>
										<div className="title">{translate('orders.details')}:</div>
										<div className="text">
											{translate('orders.code')}: <strong>{pedido.detail.discount_code}</strong><br />
											{translate('orders.products')}: <strong>${pedido.detail.products}</strong><br />
											{translate('orders.shipping')}: <strong>${pedido.detail.shipping}</strong><br />
											Subtotal: <strong>${pedido.detail.subtotal}</strong><br />
											{translate('orders.promotion')}: <strong>-${pedido.detail.discount}</strong><br />
											{/* Total (IVA incluído): <strong>$469.00</strong> */}
										</div>
									</div>
									<div></div>
								</div>
								<div className="subtitle">{translate('orders.inorder')}:</div>
								{pedido.detail.cart_products.length>0 && 
									pedido.detail.cart_products.map((ped, index) => (
										<AgregadoItem ped={ped} key={index} />
									  ))
									
								}

								{pedido.detail.reward && pedido.detail.reward.has_gift ? <GiftProduct 
									imageSrc={pedido.detail.reward.gift_image ?? require("../../assets/images/gift-product.png")}
									title={pedido.detail.reward.gift_name}
									details={pedido.detail.reward.gift_description}
									plecaText={translate('summary.gift')}
								/> : ''}
							</div>
						)}
					</div>
				)))
				:
				<>
					<PedidosLoading count={4} />
				</>
				}
			</section>

			<PodriaInteresarte />
		</>
	);
};

export default Component;